// src/components/filter.
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, CardBody, Card, Label, Modal, ModalHeader, ModalBody, Input, ModalFooter, Button } from "reactstrap";
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AdminService } from "services/AdminService";
import { useFormik } from "formik";
import { DriverSchema } from "schemas/driverSchema";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { environment } from "environment/environment";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AddressModel } from "models/City";
import { Driver } from "models/Driver";
import DriverTableContainer from "components/Common/DriverTableContainer";
import DriverDetailsModal from "modals/DriverDetailsModal";
import UpdateDriver from "./updateDriver";
import Swal from "sweetalert2";
import CustomGooglePlacesAutocomplete from "components/Common/auto-complete";
import { AddressType } from "enum/AddressType";
import "../../assets/css/custom.css";
import { Puff } from "react-loader-spinner";
import { Radio, RadioChangeEvent, Select } from "antd";
import { VehicleType } from "enum/VehicleType";
import { MobileDeviceType } from "enum/MobileDeviceType";
import { AuthService } from "services/AuthService";

const getInitials = (name: any) => {
  let initials;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    initials =
      nameSplit[0].substring(0, 1) +
      nameSplit[nameLength - 1].substring(0, 1);
  } else if (nameLength === 1) {
    initials = nameSplit[0].substring(0, 1);
  } else return;

  return initials.toUpperCase();
};

const createImageFromInitials = (size: number, name: any, color: any) => {
  if (name == null) return;
  name = getInitials(name)

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  canvas.width = canvas.height = size

  context!.fillStyle = color
  context!.fillRect(0, 0, size, size)

  context!.fillStyle = "#ffffff";
  context!.textBaseline = 'middle'
  context!.textAlign = 'center'
  context!.font = `${size / 2}px Roboto`
  context!.fillText(name, (size / 2), (size / 2))

  return canvas.toDataURL()
};

export const CustonerImage = (photoId: any) => {
  const [imgSrc, setImgSrc] = useState<any>()
  // useEffect(() => {
  //   AuthService.getProfileImage(photoId.photoId).then(res => {     
  //     setImgSrc(`data:image/*;base64,${res.data}`)
  //   })
  // }, [])
  useEffect(() => {
    AuthService.getProfileImage(photoId.photoId)
      .then(response => {
        const rawBinary = response;
        console.log("rawBinary:", rawBinary);
        const blob = new Blob([rawBinary as any], { type: 'image/jpeg' });
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === 'string') {
            console.log("Base64 Image URL:", reader.result);
            setImgSrc(reader.result);
          }
        };
        reader.readAsDataURL(blob);
      })
      .catch(err => {
        console.error("Error loading image:", err);
      });
  }, []);



  return (
    <img className="rounded-circle header-profile-user" src={imgSrc} alt="profile-pic" />
  )
}


const ManageDrivers: React.FC = () => {
  const [drivers, setDrivers] = useState([] as Driver[]);
  const [driverId, setDriverId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [LIMIT_P_C, setLIMIT_P_C] = useState(10);
  const [isPasscodeModalOpen, setIsPasscodeModalOpen] = useState(false);
  const [enteredPasscode, setEnteredPasscode] = useState("");
  const [selectedDriverId, setSelectedDriverId] = useState("");
  const [showDeactivatedOnly, setShowDeactivatedOnly] = useState(false); // NEW STATE

  const CORRECT_PASSCODE = environment.CORRECT_PASSCODE;

  const mapprops: any = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85,    // Northeast corner latitude (Keep this as is)
      south: 41.6,     // Southwest corner latitude (Keep this as is)
      east: -74.0,     // Adjusted Northeast corner longitude to cover Kingston and Cornwall
      west: -95.15     // Keep this as is to cover the entire Ontario province
    }
  };

  // Filter drivers based on deactivated status
  const filteredDrivers = useMemo(() => {
    if (showDeactivatedOnly) {
      // Show only deactivated drivers when filter is checked
      return drivers.filter(driver =>
        driver.verifiedStatus === 'deactive'
      );
    } else {
      // Show only verified/active drivers by default
      return drivers.filter(driver =>
        driver.verifiedStatus !== 'deactive'
      );
    }
  }, [drivers, showDeactivatedOnly]);

  const columns = useMemo(
    () => [
      {
        id: "customerImage",
        Header: "",
        //accessor: "firstName",
        Cell: ({ row }: any) => {
          return (
            <div className="text-center">
              {row.original.photoId !== undefined && row.original.photoId !== "" && row.original.photoId !== null ? (
                <CustonerImage photoId={row.original.photoId} />
              ) : (
                <img
                  className="rounded-circle header-profile-user"
                  id='preview'
                  src={createImageFromInitials(40, row.original.firstName, "#ff115a")}
                  alt="profile-pic"
                />
              )}

            </div>
          )
        },
      },

      {
        Header: "Driver Id",
        accessor: "customerId",
      },
      {
        Header: "Driver Name",
        accessor: "firstName",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Address",
        accessor: "address.city",
        Cell: ({ row }: any) => {
          const value = String(row.original.address?.city || "").split(",");
          const count = value.length;
          const city = count - 3 >= 0 ? value[count - 3] : "";
          return city;
        },
      },
      {
        Header: "Phone Number",
        accessor: "phoneNumber",
      },
      {
        Header: "Vehicle",
        accessor: "vehicleType",
      },
      {
        Header: "verified Status",
        accessor: "verifiedStatus",
      },
      {
        id: "action",
        Header: "Action",
        accessor: "_id",
        Cell: ({ row }: any) => {
          return (
            <div className="text-center">
              <button className="btn btn-primary btn-sm me-lg-2 mb-2" onClick={() => handleAction(row)}>
                View
              </button>
              <button className="btn btn-outline-success btn-sm me-lg-2  mb-2" onClick={(e) => { handleEditAction(row); e.currentTarget.blur(); }}>
                Edit
              </button>
              <button className="btn btn-outline-danger btn-sm  mb-2" onClick={() => deleteDriver(row)}>
                Delete
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
  const [seeMore_p_c, setSeeMore_p_c] = useState(false);
  const [address, setAddress] = useState<AddressModel>();
  const [pageCount, setPageCount] = useState<number>(1);
  const [isloading, setIsloading] = useState<boolean>(true);
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    typeOfPhone: "",
    phoneNumber: "",
    percentage: "",
    password: "",
    confirmPassword: "",
    vehicleType: "",
    mobileDeviceType: "",
    vehicleBrand: "",
    vehicleModel: "",
    vehicleYear: "",
    vehiclePrice: "",
    vehicleLicense: "",
    userName: "",
  };

  useEffect(() => {
    setIsloading(true);
    AdminService.getDrivers(LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
      } else {
        setSeeMore_p_c(true);
      }
    });
    setIsloading(false);
  }, [isEditClicked]);

  const SeeMore = (page: any) => {
    setOffset_p_c(page.selected + 1);
    AdminService.getDrivers(LIMIT_P_C, page.selected + 1).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
      } else {
        setSeeMore_p_c(true);
      }
    });
  };

  const onSubmit = async (values: typeof initialValues, actions: any) => {
    const submitData: Driver = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      typeOfPhone: values.typeOfPhone,
      phoneNumber: values.phoneNumber,
      address: address,
      percentage: values.percentage,
      password: values.password,
      vehicleType: values.vehicleType,
      mobileDeviceType: values.mobileDeviceType,
      vehicle: {
        vehicle: values.vehicleType,
        brand: values.vehicleBrand,
        model: values.vehicleModel,
        year: values.vehicleYear,
        license: values.vehicleLicense,
        price: parseFloat(values.vehiclePrice) || 0,
      },
      userName: values.userName
    };
    if (address?.city == "" || address?.city == undefined) {
      toast.error("Address is required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    } else {
      await AdminService.createDriver(submitData)
        .then(res => {
          if (res.success) {
            actions.resetForm();
            toast.success("Successfully Added New Driver!.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
              style: { marginBottom: "4rem" },
            });
            AdminService.getDrivers(LIMIT_P_C, isOffset_p_c).then(res => {
              if (res.success) {
                setDrivers(res.data.driverList);
                setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
              } else {
                setSeeMore_p_c(true);
              }
            });
          } else {
            toast.error(res.error, {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
              style: { marginBottom: "4rem" },
            });
          }
        });
    }
  };

  const deleteDriver = (values: any) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        AdminService.deleteDriverById(values.original?._id).then(res => {
          if (res.success) {
            SeeMore(isOffset_p_c);
            // setDrivers(drivers.filter((Driver) => Driver._id !== driver._id));
            Swal.fire("Driver Removed");
          } else {
            Swal.fire({
              icon: "error",
              title: res.error,
              confirmButtonColor: "#FD7F00",
            });
          }
        });
      }
    });
  };

  const handleColumnChange = (selectedOption: any) => {
    setLIMIT_P_C(selectedOption.value);
    AdminService.getDrivers(selectedOption.value, 1).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
        setPageCount(Math.ceil(res.data.count / selectedOption.value));
      } else {
        setSeeMore_p_c(true);
      }
    });
  };

  const handleAddress = async (label: string, place_id: string, type: string) => {
    if (place_id !== "") {
      const address = label;
      await geocodeByPlaceId(place_id)
        .then(([place]: google.maps.GeocoderResult[]) => {
          const { long_name: postalCode = "" } = place.address_components.find(c => c.types.includes("postal_code")) || {};
          const latLng = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          setAddress({ city: address, lat: latLng.lat, lng: latLng.lng, postalCode: postalCode });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  const { values, errors, touched, isSubmitting, handleBlur, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      typeOfPhone: "Mobile",
      phoneNumber: "",
      percentage: "",
      vehicleType: "",
      mobileDeviceType: "",
      password: "",
      confirmPassword: "",
      vehicleBrand: "",
      vehicleModel: "",
      vehicleYear: "",
      vehiclePrice: "",
      vehicleLicense: "",
      userName: "",
    },
    validationSchema: DriverSchema,
    onSubmit, // Fix the attribute name here
  });

  // const handleAction = (values: any) => {
  //   toggleOrderModalInput(values.original?._id);
  // };
  const handleAction = (values: any) => {
    setSelectedDriverId(values.original?._id);
    setIsPasscodeModalOpen(true);
  };
  const handlePasscodeSubmit = () => {
    if (enteredPasscode === CORRECT_PASSCODE) {
      setIsPasscodeModalOpen(false);
      toggleOrderModalInput(selectedDriverId);
      setEnteredPasscode("");
    } else {
      toast.error("Incorrect passcode. Try again.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setEnteredPasscode("");
    }
  };

  const handleEditAction = (values: any) => {
    toggleEdiyModalInput(values.original?._id);
  };

  const handleModal = () => {
    setIsClicked(!isClicked);
  };

  const toggleOrderModalInput = (id: any) => {
    setDriverId(id);
    setIsClicked(isClicked => {
      if (!isClicked) {
        handleModal();
      }
      return !isClicked;
    });
  };

  const handleEditModal = () => {
    setIsEditClicked(!isEditClicked);
  };

  const toggleEdiyModalInput = (id: any) => {
    setDriverId(id);
    setIsEditClicked(isEditClicked => {
      if (!isEditClicked) {
        handleEditModal();
      }
      return !isEditClicked;
    });
  };

  const searchTable = (serchText: string) => {
    const searchdata = {
      searchableString: serchText,
    };
    AdminService.getDriverBySearch(searchdata, LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        if (res.data.length !== 0) {
          setDrivers(res.data);
        }
      }
    });
  };

  // NEW FUNCTION: Handle deactivated filter toggle
  const handleDeactivatedFilter = (checked: boolean) => {
    setShowDeactivatedOnly(checked);
  };

  const handleRadioChange = (event: RadioChangeEvent) => {
    const selectedValue = event.target.value;
    setFieldValue("vehicleType", selectedValue);
  };

  const handleRadioChangeDevice = (event: RadioChangeEvent) => {
    const selectedValue = event.target.value;
    setFieldValue("mobileDeviceType", selectedValue);
  };

  //meta title
  document.title = "Manage Drivers";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Manage Drivers" breadcrumbItem={"Create"} />
        <Col lg={12}>
          <Card>
            <CardBody>
              <Modal isOpen={isPasscodeModalOpen} toggle={() => setIsPasscodeModalOpen(false)}>
                <ModalHeader toggle={() => setIsPasscodeModalOpen(false)}>
                  Enter Passcode to View Details
                </ModalHeader>
                <ModalBody>
                  <Input
                    type="password"
                    placeholder="Enter passcode"
                    value={enteredPasscode}
                    onChange={(e) => setEnteredPasscode(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handlePasscodeSubmit();
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={() => setIsPasscodeModalOpen(false)}>
                    Cancel
                  </Button>
                  <Button color="primary" onClick={handlePasscodeSubmit}>
                    Verify
                  </Button>
                </ModalFooter>
              </Modal>
              <DriverDetailsModal isOpen={isClicked} handleIsOpen={handleModal} driverId={driverId} />
              <UpdateDriver isOpen={isEditClicked} handlePopup={handleEditModal} driverId={driverId} />
              <div>Create Driver</div>
              <form onSubmit={handleSubmit} autoComplete="off">
                <React.Fragment>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-phoneno-input3" className="place-order-title">
                          First Name <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.firstName}
                          onChange={handleChange}
                          id="firstName"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className={errors.firstName && touched.firstName ? "input-error form-control" : "form-control"}
                        />
                        {errors.firstName && touched.firstName && <p className="error place-order-title">{errors.firstName}</p>}
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-email-input4" className="place-order-title">
                          Last Name <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.lastName}
                          onChange={handleChange}
                          id="lastName"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className={errors.lastName && touched.lastName ? "input-error form-control" : "form-control"}
                        />
                        {errors.lastName && touched.lastName && <p className="error place-order-title">{errors.lastName}</p>}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-phoneno-input3" className="place-order-title">
                          Address <Label className="title-star">*</Label>
                        </Label>
                        <div>
                          <CustomGooglePlacesAutocomplete
                            apiKey={environment.google_maps_key}
                            autocompletionRequest={mapprops}
                            addressType={AddressType.pickup}
                            selectProps={{
                              name: "address",
                            }}
                            handleAddress={handleAddress}
                          />
                        </div>
                        {address?.city === undefined ||
                          address?.city === "" ||
                          (address?.city === null && <p className="text-danger">You have to select a address.</p>)}
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-email-input4" className="place-order-title">
                          Email <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.email}
                          onChange={handleChange}
                          id="email"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className={errors.email && touched.email ? "input-error form-control" : "form-control"}
                        />
                        {errors.email && touched.email && <p className="error place-order-title">{errors.email}</p>}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-phoneno-input3" className="place-order-title">
                          Phone Number <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.phoneNumber}
                          onChange={handleChange}
                          id="phoneNumber"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className={errors.phoneNumber && touched.phoneNumber ? "input-error form-control" : "form-control"}
                        />
                        {errors.phoneNumber && touched.phoneNumber && <p className="error place-order-title">{errors.phoneNumber}</p>}
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-email-input4" className="place-order-title">
                          Percentage <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.percentage}
                          onChange={handleChange}
                          id="percentage"
                          type="number"
                          placeholder=""
                          onBlur={handleBlur}
                          className={errors.percentage && touched.percentage ? "input-error form-control" : "form-control"}
                        />
                        {errors.percentage && touched.percentage && <p className="error place-order-title">{errors.percentage}</p>}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="vehicleBrand" className="place-order-title">
                          Vehicle Brand
                        </Label>
                        <input
                          value={values.vehicleBrand}
                          onChange={handleChange}
                          id="vehicleBrand"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className="form-control"
                        />
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="vehicleModel" className="place-order-title">
                          Vehicle Model
                        </Label>
                        <input
                          value={values.vehicleModel}
                          onChange={handleChange}
                          id="vehicleModel"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className="form-control"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="vehicleYear" className="place-order-title">
                          Vehicle Year
                        </Label>
                        <input
                          value={values.vehicleYear}
                          onChange={handleChange}
                          id="vehicleYear"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          maxLength={4}
                          className="form-control"
                        />
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="vehicleLicense" className="place-order-title">
                          Vehicle License Plate (Optional)
                        </Label>
                        <input
                          value={values.vehicleLicense}
                          onChange={handleChange}
                          id="vehicleLicense"
                          type="text"
                          placeholder=""
                          onBlur={handleBlur}
                          className="form-control"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-declaration-input10" className="place-order-title">
                          Mobile Device Type<Label className="title-star">*</Label>
                        </Label>
                        <div className="col-lg-6 form-check">
                          <Radio.Group value={values.mobileDeviceType} onChange={handleRadioChangeDevice} onBlur={handleBlur}>
                            <Radio value={MobileDeviceType.iOS}>iOS</Radio>
                            <Radio value={MobileDeviceType.Android}>Android</Radio>
                          </Radio.Group>
                        </div>
                        {errors.mobileDeviceType && touched.mobileDeviceType && (
                          <p className="error place-order-title">{errors.mobileDeviceType}</p>
                        )}
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-declaration-input10" className="place-order-title">
                          Type Of Vehicle<Label className="title-star">*</Label>
                        </Label>
                        <div className="col-lg-6 form-check">
                          <Radio.Group value={values.vehicleType} onChange={handleRadioChange} onBlur={handleBlur}>
                            <Radio value={VehicleType.CAR}>Car</Radio>
                            <Radio value={VehicleType.SUV}>SUV</Radio>
                            <Radio value={VehicleType.VAN}>Mini Van</Radio>
                          </Radio.Group>
                        </div>
                        {errors.vehicleType && touched.vehicleType && (
                          <p className="error place-order-title">{errors.vehicleType}</p>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-phoneno-input3" className="place-order-title">
                          User Name <Label className="title-star">*</Label>
                        </Label>
                        <input
                          type="text"
                          id="userName"
                          value={values.userName}
                          placeholder=""
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={errors.userName && touched.userName ? "input-error form-control" : "form-control"}
                        />
                        {errors.userName && touched.userName && <p className="error place-order-title">{errors.userName}</p>}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-password-input" className="place-order-title">
                          Set Password <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.password}
                          onChange={handleChange}
                          id="password"
                          type="password"
                          placeholder=""
                          onBlur={handleBlur}
                          autoComplete="new-password" // Prevent brow
                          className={errors.password && touched.password ? "input-error form-control" : "form-control"}
                        />
                        {errors.password && touched.password && <p className="error place-order-title">{errors.password}</p>}
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="mb-3 form-group">
                        <Label for="basicpill-confirmpassword-input" className="place-order-title">
                          Confirm Pssword <Label className="title-star">*</Label>
                        </Label>
                        <input
                          value={values.confirmPassword}
                          onChange={handleChange}
                          id="confirmPassword"
                          type="password"
                          placeholder=""
                          onBlur={handleBlur}
                          className={errors.confirmPassword && touched.confirmPassword ? "input-error form-control" : "form-control"}
                        />
                        {errors.confirmPassword && touched.confirmPassword && <p className="error place-order-title">{errors.confirmPassword}</p>}
                      </div>
                    </Col>
                  </Row>
                  <div className="clearfix">
                    <div className="d-lg-flex d-md-flex justify-content-lg-end justify-content-md-end">
                      <button disabled={isSubmitting} type="submit" className="btn btn-primary btn-sm px-5 me-lg-2 me-md-2 mb-2 ms-1">
                        Create
                      </button>
                    </div>
                  </div>
                </React.Fragment>
              </form>
            </CardBody>
          </Card>
        </Col>
        <Col lg={12}>
          <Card>
            <CardBody>
              {/* NEW FILTER SECTION - ADDED HERE */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>Driver List</div>
                <div className="d-flex align-items-center">
                  <Label check className="me-2 mb-0">
                    Show Deactivated Only
                  </Label>
                  <Input
                    type="checkbox"
                    checked={showDeactivatedOnly}
                    onChange={(e) => handleDeactivatedFilter(e.target.checked)}
                    className="form-check-input"
                  />
                </div>
              </div>

              {isloading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
                <Puff color="#FFD0B8" height={50} width={50} />
              </div> :
                <>{filteredDrivers.length > 0 ? ( // CHANGED: drivers to filteredDrivers
                  <DriverTableContainer
                    columns={columns}
                    data={filteredDrivers} // CHANGED: drivers to filteredDrivers
                    currentPage={isOffset_p_c}
                    pagelimit={pageCount}
                    handlePageChange={SeeMore}
                    handleSearch={searchTable}
                    handleColumnChange={handleColumnChange}
                    selectedColumns={LIMIT_P_C}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    customPageSize={50}
                    className="custom-header-css"
                    isJobListGlobalFilter={undefined}
                    isAddUserList={undefined}
                    handleOrderClicks={undefined}
                    handleUserClick={undefined}
                    handleCustomerClick={undefined}
                    isAddCustList={undefined}
                    customPageSizeOptions={undefined}
                    isPDFGenerate={true}
                    ispopup={true}
                    isAddressBook={false}
                    hancleDeleteRecords={undefined}
                    handleSelect={undefined}
                    selectedID={undefined}
                    isABusiness={true}
                  />
                ) : (
                  <Row className="justify-content-md-center justify-content-center align-items-center">
                    <Col className="col-md-auto">
                      <div>No Drivers to show</div>
                    </Col>
                  </Row>
                )}</>}
            </CardBody>
          </Card>
        </Col>
      </div>
    </div>
  );
};

export default ManageDrivers;
